import { useMutation, useQueryClient } from '@tanstack/react-query';
import { availabilityReportService } from '@/services';
import { queryKeys } from '@/services/query-keys';
import { AvailabilityReportDetail } from '@/types';
import { logger } from '@/utils/logger';

interface ResetPayload {
  reportId: number;
}

type ResetOptions = {
  onSuccess?: (data: AvailabilityReportDetail) => void;
  onError?: (error: Error) => void;
};

export const useResetAvailabilityReport = (options?: ResetOptions) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ reportId }: ResetPayload) =>
      availabilityReportService.resetReport(reportId),
    onSuccess: async (data, { reportId }) => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.availabilityReport.detail(reportId) });
      await queryClient.invalidateQueries({ queryKey: queryKeys.availabilityReport.list() });
      options?.onSuccess?.(data);
    },
    onError: (error: Error) => {
      logger.error('Failed to reset availability report:', error);
      options?.onError?.(error);
    },
  });
};
